export const dataSource: { [key: number]: { nama: string; group: string } } = {
  1: {
    nama: "Spend Money",
    group: "Spend Money transactions"
  },
  2: {
    nama: "Receive Money",
    group: "Receive Money transactions"
  },
  3: {
    nama: "General Entry",
    group: "General transactions"
  },
  4: {
    nama: "Transfer Money",
    group: "Transfer Money transactions"
  },
  5: {
    nama: "Purchase Order",
    group: "Purchases transactions"
  },
  6: {
    nama: "Create Bill",
    group: "Purchases transactions"
  },
  7: {
    nama: "Payment Deposit Vendor",
    group: "Purchases transactions"
  },
  8: {
    nama: "Opening Balance Account",
    group: "Account Transactions transactions"
  },
  9: {
    nama: "Payment Bill",
    group: "Purchases transactions"
  },
  10: {
    nama: "Sales Order",
    group: "Sales transactions"
  },
  11: {
    nama: "Create Invoice",
    group: "Sales transactions"
  },
  12: {
    nama: "Payment Deposit Customer",
    group: "Sales transactions"
  },
  13: {
    nama: "Payment Invoice",
    group: "Sales transactions"
  },
  14: {
    nama: "Opening Stock",
    group: "Inventory transactions"
  },
  15: {
    nama: "Create Bill Detail",
    group: " transactions"
  },
  16: {
    nama: "Create Invoice Detail",
    group: " transactions"
  },
  17: {
    nama: "Average Price Real",
    group: " transactions"
  },
  18: {
    nama: "Reject Item",
    group: "Purchases transactions"
  },
  19: {
    nama: "Reject Item Detail",
    group: " transactions"
  },
  20: {
    nama: "Return Item",
    group: "Sales transactions"
  },
  21: {
    nama: "Return Item Detail",
    group: " transactions"
  },
  22: {
    nama: "Transfer Inventory",
    group: "Inventory transactions"
  },
  23: {
    nama: "Transfer Inventory Detail",
    group: " transactions"
  },
  24: {
    nama: "Received Inventory",
    group: "Inventory transactions"
  },
  25: {
    nama: "Received Inventory Detail",
    group: " transactions"
  },
  26: {
    nama: "Reject Transfer",
    group: " transactions"
  },
  27: {
    nama: "Adjustment Inventory",
    group: "Inventory transactions"
  },
  28: {
    nama: "Adjustment Inventory Detail",
    group: " transactions"
  },
  29: {
    nama: "Average Price Last",
    group: " transactions"
  },
  30: {
    nama: "POS",
    group: "Sales transactions"
  },
  31: {
    nama: "Payment POS",
    group: "Sales transactions"
  },
  34: {
    nama: "Received Reject",
    group: "Received Reject transactions"
  },
  36: {
    nama: "Payment POS",
    group: "Build Items"
  },
  37: {
    nama: "Payment POS",
    group: "Build Items"
  },
  38: {
    nama: "Asset depreciation",
    group: "Asset depreciation"
  },
  39: {
    nama: "Asset disposal",
    group: "Asset disposal"
  },
  40: {
    nama: "Refund return",
    group: "Refund return"
  }
}
